import { Component, Input } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';
import { JobQualificationsChangeTypeEnum } from '../../../enums/job-qualifications-change-type.enum';
import { JobQualificationChange } from '../../../models/job-qualification-change.model';
import { NullDashPipe } from 'src/app/shared/pipes/null-dash.pipe';
import { NgIf } from '@angular/common';
import { StaffingRatioPipe } from 'src/app/shared/pipes/staffing-ratio.pipe';

@UntilDestroy()
@Component({
    selector: 'nova-job-qualifications-patient-ratio-change',
    templateUrl: './job-qualifications-patient-ratio-change.component.html',
    styleUrls: ['./job-qualifications-patient-ratio-change.component.scss'],
    standalone: true,
    imports: [NgIf, NullDashPipe, StaffingRatioPipe]
})
export class JobQualificationsPatientRatioChangeComponent {
    @Input()
    change: JobQualificationChange<string>;

    changeType = JobQualificationsChangeTypeEnum;
    originalValue?: string;
    newValue?: string;
}
